import api from "../index"

const aboutUsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAboutPrachay: build.query({
      query: ({ user_type }) => ({
        url: `/${user_type}/content/about-us`,
        method: "GET",
      }),
    }),

    getAboutIcd: build.query({
      query: ({ user_type }) => ({
        url: `/${user_type}/content/about-icd`,
        method: "GET",
      }),
    }),
    getFaqs: build.query({
      query: ({ user_type }) => ({
        url: `/${user_type}/content/faqs`,
        method: "GET",
      }),
    }),
  }),
})

export const {
  useLazyGetAboutPrachayQuery,
  useLazyGetAboutIcdQuery,
  useLazyGetFaqsQuery,
} = aboutUsApi
